// src/utils/toast.js
import toast from "react-hot-toast";

/**
 * Unified toast helper — use this everywhere instead of toast.success() / toast.error()
 * Styling is handled globally in App.js <Toaster> config.
 *
 * @param {string} message  - Text to show
 * @param {"success"|"error"} type - Defaults to "success"
 */
export function showToast(message, type = "success") {
  if (type === "error") {
    toast.error(message);
  } else {
    toast.success(message);
  }
}